export var TriggerType;
(function (TriggerType) {
    TriggerType[TriggerType["GoToControl"] = 0] = "GoToControl";
    TriggerType[TriggerType["TriggerAction"] = 1] = "TriggerAction";
    TriggerType[TriggerType["RunValidation"] = 2] = "RunValidation";
    TriggerType[TriggerType["RunDataFlow"] = 3] = "RunDataFlow";
    TriggerType[TriggerType["RunActiveFormFlow"] = 4] = "RunActiveFormFlow";
})(TriggerType || (TriggerType = {}));
;
